import { render, staticRenderFns } from "./dangerousGoodsListStorageClassification.vue?vue&type=template&id=76903a06&scoped=true"
import script from "./dangerousGoodsListStorageClassification.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsListStorageClassification.vue?vue&type=script&lang=js"
import style0 from "./dangerousGoodsListStorageClassification.vue?vue&type=style&index=0&id=76903a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76903a06",
  null
  
)

export default component.exports